/** The tab icon: a diamond from the game's own sprites, drawn at load (there are no image files). */

import { atlasFor } from '../render/atlas';
import { makeCanvas } from '../render/canvas';

export function installFavicon(): void {
  try {
    const canvas = makeCanvas(32, 32);
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    ctx.imageSmoothingEnabled = false;
    ctx.scale(2, 2);
    atlasFor([6, 14, 1]).draw(ctx, 'diamond', 0, 0, 0);
    const link = document.createElement('link');
    link.rel = 'icon';
    link.href = canvas.toDataURL('image/png');
    document.head.append(link);
  } catch {
    // No icon is no loss.
  }
}
